import PhaseType from './PhaseType'

const historyReducer = (state, action) => {
  switch (action.type) {
    case PhaseType.GET_PHASES:
      return {
        ...state,
        round: action.payload,
        loading: false,
      }
    case PhaseType.GET_PHASE:
      return {
        ...state,
        phase: action.payload,
        loading: false,
      }
    case PhaseType.CREATE_PHASE:
      return {
        ...state,
        phase: action.payload,
        loading: false,
      }
    case PhaseType.UPDATE_PHASE:
      return {
        ...state,
        phase: action.payload,
        loading: false,
      }
    case PhaseType.DELETE_PHASE:
      return {
        ...state,
        phase: {},
        loading: false,
      }
    case 'SET_LOADING':
      return {
        ...state,
        loading: true,
      }
    default:
      return state
  }
}

export default historyReducer
